import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * Minimal error boundary: shows a friendly fallback for one panel without
 * breaking the rest of the page.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", this.props.label, error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div
          className="rounded-md border border-rose-400/50 bg-rose-50 p-5 text-sm text-rose-900 dark:border-rose-500/40 dark:bg-rose-950/40 dark:text-rose-100"
          data-testid={`error-boundary-${this.props.label || "panel"}`}
        >
          <div className="flex items-start gap-2">
            <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-rose-600 dark:text-rose-300" />
            <div>
              <div className="font-bold">
                Ce module n'a pas pu s'afficher.
              </div>
              <div className="mt-1 text-xs opacity-80">
                Détail : {String(this.state.error?.message || this.state.error)}
              </div>
              <button
                type="button"
                onClick={() => this.setState({ error: null })}
                className="mt-3 rounded-md border border-rose-300 bg-white px-3 py-1 text-xs font-semibold text-rose-800 hover:bg-rose-100 dark:bg-rose-950/60 dark:text-rose-100"
              >
                Réessayer
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
